import { useMsal } from "@azure/msal-react";
import { useLocation, useNavigate } from "react-router-dom";
import { useUserDetails } from "../../hooks/useUserDetails";
import { InteractionStatus } from "@azure/msal-browser";
import { debounce, getAuthProvider } from "../../common/utils";
import { Env, Paths } from "../../common/constants";
import { RedirectInfo } from "../../pages/organization/services/type";
import { getUserAppRedirect } from "../../pages/organization/services/action";
import { useAppDispatch } from "../../hooks/useAppDispatch";
import { useAppSelector } from "../../hooks/useAppSelector";
import { RootState } from "../../redux/store";

const useHeaderHelper = () => {
  const { instance, inProgress } = useMsal();
  const userData = useUserDetails();
  const location = useLocation();
  const navigate = useNavigate();
  const dispatch = useAppDispatch();
  const pathName = location.pathname;

  const { profile } = useAppSelector((state: RootState) => state.organization);
  const showRbacButton = profile?.role === 1;

  const country = localStorage.getItem("country");
  const parsedCountry = country ? JSON.parse(country) : null;

  const brand = localStorage.getItem("brand");
  const parsedBrand = brand ? JSON.parse(brand) : null;

  const handleLogout = debounce(() => {
    // Handle logout based on auth type
    const authProvider = getAuthProvider();

    if (authProvider === "microsoft" && inProgress === InteractionStatus.None) {
      // Microsoft auth: use MSAL logout
      sessionStorage.setItem("msal_logout_in_progress", "true");

      // Don't clear localStorage before redirect - let MSAL handle the redirect first
      // The login page will clear it when it detects the logout
      instance.logoutRedirect({
        postLogoutRedirectUri: "/",
      });
    } else {
      // Manual auth: clear storage and redirect to login
      localStorage.clear();
      sessionStorage.clear();
      navigate("/");
    }
  }, 500);

  const handleNavigate = () => {
    navigate(Paths.ORGANIZATION);
  };

  const handleRbac = () => {
    dispatch(
      getUserAppRedirect({
        appId: 1,
        successFn: (data: RedirectInfo) => handleSuccess(data),
      })
    );
  };

  const handleSuccess = async (data: RedirectInfo) => {
    const jwtToken = encodeURIComponent(data?.jwtToken);
    const lsIdToken = localStorage.getItem("idToken");
    const idTokenQuery = lsIdToken
      ? `&idToken=${encodeURIComponent(lsIdToken)}`
      : "";
    window.location.href = `${Env.PORTAL_URL}#/rbac/user-management?token=${jwtToken}${idTokenQuery}`;
  };

  return {
    userData,
    pathName,
    handleLogout,
    parsedBrand,
    parsedCountry,
    handleNavigate,
    handleRbac,
    showRbacButton,
  };
};

export default useHeaderHelper;
